import React from 'react'

// checkColor defaults to grey — a green check here would misread as "already
// verified" on the ask screens. Callers that genuinely mean "done" (e.g. the
// stepper's completed step) can override it to green.
const EmailVerificationEnvelopeIllustration = (props) => {
  const {
    checkColor, width, height, className,
  } = props
  return (
    <svg
      className={className || 'emailVerificationFlow-illustration'}
      width={width}
      height={height}
      viewBox='0 0 72 58'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='2' y='16' width='52' height='38' rx='5' fill='#4199FF' />
      <path d='M2 16L28 36L54 16Z' fill='#0072FF' />
      <circle cx='58' cy='16' r='14' fill={checkColor} stroke='white' strokeWidth='3' />
      <path d='M51 16L56 21L66 10' stroke='white' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

EmailVerificationEnvelopeIllustration.defaultProps = {
  checkColor: '#C4C3CD',
  width: 72,
  height: 58,
  className: undefined,
}

export default EmailVerificationEnvelopeIllustration
